import UsersTable from '../components/UsersTable/UsersTable.vue'

export default {
  components: {
    UsersTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
